// do not change the default if you want to change it then you should change the decimal separator in useCurrency
const DUTCH_URL = import.meta.env.VITE_DUTCH_URL;
const ENGLISH_URL = import.meta.env.VITE_ENGLISH_URL;

const Locales = {
  default: {
    locale: 'en-US',
    lng: 'en'
  },
  [DUTCH_URL]: {
    locale: 'nl-NL',
    lng: 'nl'
  },
  [ENGLISH_URL]: {
    locale: 'en-US',
    lng: 'en'
  }
};

export default Locales;
